import { isDarkmode } from "../../connections/atlassian/ap";
import "ace-builds/src-noconflict/theme-dawn";
import "ace-builds/src-noconflict/theme-twilight";
export const getAceEditorTheme = () => {
  if (isDarkmode()) {
    return "twilight";
  }
  return "dawn";
};
